import { Grid2, Typography, Avatar, ButtonBase } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { useStyles } from './styles';
import { ROUTES } from 'core/routing/routes';
import { useAuth } from 'core/contexts/auth';

const ExperiecerData = () => {
    const name = 'Colorious';
    const description = '';

    const classes = useStyles();
    const history = useHistory();

    const { userInfo, getUserInfoSync } = useAuth();

    useEffect(() => {
        getUserInfoSync();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Grid2 container className={classes.container}>
                <Grid2 sx={{ width: 'fitContent', height: 'auto' }}>
                    <ButtonBase onClick={() => history.push(ROUTES.PROFILE)}>
                        <Avatar className={classes.avatar} src={userInfo?.experiencer?.pictureURL ? `${process.env.REACT_APP_CDN_URL}${userInfo?.experiencer?.pictureURL}` : null} />
                    </ButtonBase>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 8 }}>
                    <div className={classes.textContainer}>
                        <div>
                            <Typography variant="h5" className={classes.text} noWrap>
                                {userInfo?.experiencer?.name || name}
                            </Typography>
                            {/* <IconButton
              onClick={() => history.push(ROUTES.PROFILE)}
              aria-label="edit"
              color="primary"
              className={classes.editButton}>
              <img alt="edit" style={{ width: '1em' }} src={EditIcon} />
            </IconButton> */}
                        </div>
                        <Typography variant="h6" className={classes.text}>
                            {userInfo?.experiencer?.description || description}
                        </Typography>
                    </div>
                </Grid2>
            </Grid2>
        </>
    );
};

ExperiecerData.displayName = 'ExperiecerData';

export default ExperiecerData;
